import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareSurveysQuery } from '@widgets/surveys'
import { toIdValue } from '@shared/lib/routes'

import { defineNuxtRouteMiddleware } from '#app'

/** `/disciplines/{id}/surveys` — the surveys table limited to the discipline. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const disciplineId = toIdValue(to.params.id)
  if (!disciplineId) return

  return useMiddlewareSurveysQuery(to, disciplineId)
})
